<template>
    <div class="content-page">
        <!-- pc端 -->
        <div class="pc-header">
            <crumbs></crumbs>
            <div class="operate-group">
                <div class="box tabs-box">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="客户视角" name="first"></el-tab-pane>
                        <el-tab-pane label="账号视角" name="second"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="add-btn" v-if="activeName == 'first'" @click="handleaAddUser">
                    <img src="../../assets/image/icon-add-user.svg" alt="" /> 新增客户
                </div>
            </div>
            <div class="box filter-box">
                <div class="filter-line">
                    <div class="title-name">学校名称：</div>
                    <div class="filter-ipt">
                        <el-input prefix-icon="el-icon-search" v-model="form.schoolName" placeholder="搜索学校名称" class="no-border" @change="initListData"
                            clearable></el-input>
                    </div>
                </div>
                <!-- 筛选：所在省份 -->
                <div class="filter-line">
                    <div class="title-name">所在省份：</div>
                    <div class="filter-select">
                        <el-select v-model="form.provinceId" placeholder="学校所在省份" filterable clearable @change="initListData">
                            <el-option v-for="item in provinceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <!-- 筛选：产品分类 -->
                <CheckedSelect v-model="form.productIdList" :options="[{id:'',name:'全部'}, ...productList]" label="产品分类" :props="{multi:true}" @change="handleProductFilterChange" />
                <!-- 筛选：产品版本（所选产品有版本时显示） -->
                <CheckedSelect v-if="versionOptions.length" v-model="form.versionIdList" :options="[{id:'',name:'全部'}, ...versionOptions]" label="产品版本" :props="{multi:true}"
                    @change="initListData" />
                <!-- 筛选：订购类型 -->
                <CheckedSelect v-model="form.orderType" :options="orderTypeList" label="订购类型" @change="initListData" />
                <!-- 筛选：销售人员 -->
                <template v-if="[3, 7].indexOf($store.state.userData.type) == -1">
                    <CheckedSelect v-model="form.saleUserId" :options="salePersonOption" label="销售人员" @change="initListData" />
                </template>
                <!-- 筛选：拜访日期 -->
                <div class="filter-line" v-if="activeName === 'first'">
                    <div class="title-name">拜访日期：</div>
                    <div class="filter-date-box">
                        <el-date-picker style="width: 100%" v-model="form.visitDayStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd" @change="initListData">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker style="width: 100%" v-model="form.visitDayEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd" @change="initListData">
                        </el-date-picker>
                    </div>
                </div>
                <!-- 筛选：到期状态 -->
                <CheckedSelect v-model="form.statusList" :options="[{id:'',name:'全部'},{id:0,name:'正常'},{id:1,name:'即将到期'},{id:2,name:'已到期'}]" label="到期状态"
                    :props="{multi:true}" @change="initListData" />
                <div class="export-box">
                    <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button>
                </div>
            </div>
        </div>
        <!-- 手机端 -->
        <div class="mobile-header">
            <div class="top-tabs">
                <expandMenuIcon></expandMenuIcon>
                <el-tabs class="custom-tabs-style" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="客户视角" name="first"></el-tab-pane>
                    <el-tab-pane label="账号视角" name="second"></el-tab-pane>
                </el-tabs>
                <div class="add-user-box" v-if="activeName == 'first'" @click="handleaAddUser">
                    <i class="el-icon-plus add-user"></i>
                </div>
            </div>
            <div class="filter-line">
                <div class="filter">
                    <el-input placeholder="搜索学校名称" v-model="form.schoolName" class="no-border" @change="initListData">
                        <i slot="suffix" class="el-icon-search search-btn" @click="initListData"></i>
                    </el-input>
                </div>
                <div class="add-btn" @click="showMobileFilter = true">筛选<i class="el-icon-caret-bottom"></i></div>
            </div>
        </div>

        <customer v-if="activeName == 'first'" :dataList="customDataList" @menuClick="handleMenuClick"></customer>
        <accountNumber v-else :dataList="accountDataList"></accountNumber>
        <div v-if="loading && total > form.limit" class="load-text">正在加载中...</div>

        <pagination v-show="total" :total="total" :page.sync="form.currentPage" :limit.sync="form.limit" :pageSizes="[6, 12, 24, 48]" @pagination="updateList" />
        <filterDrawer :showMobileFilter.sync="showMobileFilter" :form="form" :active="activeName" @confirm="handleConfirm"></filterDrawer>
        <addUserDrawer :drawer.sync="addDrawer" @updateList="initListData"></addUserDrawer>
        <editUserDrawer :visible.sync="editDrawer" :data="editData" :sid="editId" :sname="editName" @updateList="initListData" />
        <delConfirm :visible.sync="delDrawer" title="删除客户" :id="editId" :sname="editName" @change="findCustomerProductPageApi" />
    </div>
</template>
<script>
import customer from "./components/customer.vue";
import accountNumber from "./components/accountNumber.vue";
import filterDrawer from "./components/filterDrawer.vue";
import addUserDrawer from "./components/addUserDrawer.vue";
import editUserDrawer from "./components/editUserDrawer.vue";
import delConfirm from "./components/delConfirm.vue";
import { findCustomerProductPage, findAccountProductPage, downloadCustomerProductList, downloadAccountProductList, findProductVersionList } from "@/api/customer/index.js";
import { mapState } from "vuex";

export default {
    components: {
        customer,
        accountNumber,
        filterDrawer,
        addUserDrawer,
        editUserDrawer,
        delConfirm,
    },
    data() {
        return {
            activeName: "first",
            showMobileFilter: false, // 手机端 筛选条件弹窗
            form: {
                schoolName: "",
                productIdList: [],
                versionIdList: [],
                visitDayStart: "",
                visitDayEnd: "",
                orderType: "",
                currentPage: 1,
                limit: 6,
                saleUserId: "",
                statusList: [],
                provinceId: "",
            },
            customDataList: [], //订购类型
            total: 0,
            accountDataList: [],
            addDrawer: false, // 新增客户抽屉
            editDrawer: false, // 编辑学校产品抽屉
            editData: [], // 产品列表数据
            editId: '', // 编辑的学校id
            editName: '', // 编辑的学校name
            // 删除客户
            delDrawer: false,
            loading: false,
            // 导出
            loadExport: false,
            productVersionMap: {}, // 产品id -> 版本选项列表（筛选用）
        };
    },
    computed: {
        ...mapState(["orderTypeList", "productList", "salePersonOption", "userData", "provinceOptions"]),
        // 已选产品对应的版本选项合集（按版本id去重）
        versionOptions() {
            const idMap = {};
            const list = [];
            (this.form.productIdList || []).forEach((pid) => {
                (this.productVersionMap[pid] || []).forEach((v) => {
                    if (!idMap[v.id]) {
                        idMap[v.id] = true;
                        list.push(v);
                    }
                });
            });
            return list;
        },
    },

    created() {
        if (!this.$utils.isBlank(this.$route.query.orderType)) {
            this.form.orderType = Number(this.$route.query.orderType);
        }
        if (!this.$utils.isBlank(this.$route.query.productId)) {
            this.form.productIdList = [this.$route.query.productId];
        }
        // 路由带入产品时预加载版本选项
        this.loadVersionOptions(this.form.productIdList);
        if (!this.$utils.isBlank(this.$route.query.statusList)) {
            this.form.statusList = this.$route.query.statusList.split(',');
            this.form.statusList = this.form.statusList.map(x => Number(x));
        }
        // 销售人员默认值
        this.getDefaultSale();
        this.findCustomerProductPageApi();
        if (this.$utils.isMobile()) {
            // 监听滚动
            window.addEventListener("scroll", () => {
                this.handleScroll();
            });
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", () => {
            this.handleScroll();
        });
    },
    methods: {
        getDefaultSale() {
            let saleId = ''
            if (!this.$utils.isBlank(this.$route.query.saleUserId)) {
                saleId = this.$route.query.saleUserId;
            } else {
                saleId = this.userData.userId
            }
            let flag = this.salePersonOption.findIndex((i) => i.id == saleId);
            this.form.saleUserId = flag > -1 ? saleId : "";
        },
        // 处理滚动事件
        handleScroll() {
            if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight) {
                // 用户已经滚动到页面底部
                this.loadMoreData();
            }
        },
        // 加载更多数据
        loadMoreData() {
            if (this.loading) return; // 防止重复加载
            let arr = this.activeName == "first" ? this.customDataList : this.accountDataList;
            if (arr.length >= this.total) {
                return;
            }
            this.loading = true;
            setTimeout(() => {
                this.form.currentPage += 1;
                this.updateList("scroll");
            }, 1000);
        },

        // 新增客户
        handleaAddUser() {
            this.addDrawer = true;
        },
        updateList(flag) {
            if (this.activeName == "second") {
                // 账号视角
                this.findAccountProductPageApi(flag);
            } else {
                this.findCustomerProductPageApi(flag);
            }
        },
        // 手机端筛选条件保存（移动端暂无版本筛选，清空防止残留）
        handleConfirm(productaActivedList, orderType, saleUserId, visitDayStart, visitDayEnd, statusList, provinceId) {
            this.form.productIdList = productaActivedList;
            this.form.versionIdList = [];
            this.form.orderType = orderType;
            this.form.saleUserId = saleUserId;
            this.form.visitDayStart = visitDayStart;
            this.form.visitDayEnd = visitDayEnd;
            this.form.statusList = statusList;
            this.form.provinceId = provinceId;
            this.initListData();
        },        // 重新加载页面数据
        initListData() {
            this.form.currentPage = 1;
            this.updateList();
        },
        // 加载已选产品的版本选项（带缓存）
        loadVersionOptions(productIdList) {
            (productIdList || []).forEach((pid) => {
                if (pid && !this.productVersionMap[pid]) {
                    findProductVersionList({ productId: pid })
                        .then((res) => {
                            this.$set(this.productVersionMap, pid, res.data || []);
                        })
                        .catch(() => {
                            this.$set(this.productVersionMap, pid, []);
                        });
                }
            });
        },
        // 产品分类筛选变化：重置版本选择、加载版本选项后刷新列表
        handleProductFilterChange() {
            this.form.versionIdList = [];
            this.loadVersionOptions(this.form.productIdList);
            this.initListData();
        },
        // 客户视角列表
        findCustomerProductPageApi(flag) {
            findCustomerProductPage({
                ...this.form,
            })
                .then((res) => {
                    this.loading = false;
                    if (flag == "scroll") {
                        this.customDataList.push(...res.data);
                    } else {
                        this.customDataList = res.data;
                    }
                    this.total = res.count;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
        },
        // 账号视角列表
        findAccountProductPageApi(flag) {
            findAccountProductPage({
                ...this.form,
            })
                .then((res) => {
                    this.loading = false;
                    if (flag == "scroll") {
                        this.accountDataList.push(...res.data);
                    } else {
                        this.accountDataList = res.data;
                    }
                    this.total = res.count;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
        },
        // tab切换
        handleClick(val) {
            this.activeName = val.name;
            this.form = {
                schoolName: "",
                productIdList: [],
                versionIdList: [],
                orderType: "",
                currentPage: 1,
                limit: 6,
                saleUserId: "",
                statusList: [],
                provinceId: '',
            };
            this.getDefaultSale();
            this.total = 0;

            if (this.$utils.isMobile()) {
                this.loading = false;
                window.scrollTo({ top: 0 });
            }
            this.updateList();
        },
        handleMenuClick(type, item) {
            if (type == "edit") {
                this.editDrawer = true;
                this.editId = item.sid;
                this.editName = item.sname;
                this.editData = item.schoolProductModelList;
            } else if (type == "del") {
                this.delDrawer = true;
                this.editId = item.sid;
                this.editName = item.sname;
            }
        },
        // 点击导出
        exportData() {
            this.loadExport = true;
            let params = {
                ...this.form,
            };
            delete params.limit;
            delete params.currentPage;
            let requestApi = null;
            if (this.activeName == 'first') {
                requestApi = downloadCustomerProductList;
            } else if (this.activeName == 'second') {
                requestApi = downloadAccountProductList;
            }
            if (!requestApi) return;
            requestApi(params).then(res => {
                // 处理blob
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                        this.loadExport = false;
                    });
                } else {
                    // 成功，预览/下载报告
                    this.$utils.download(res);
                    this.loadExport = false;
                }
            }).catch(err => {
                this.loadExport = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        }
    },
};
</script>
<style lang="scss" scoped>
/*pc端*/
@media only screen and (min-width: 768px) {
    .content-page {
        width: 80%;
        margin: 0 auto;
        padding-top: $pc-header-height;
        min-height: calc(100vh - #{$pc-header-height});
        padding-bottom: 4rem;
        .mobile-header {
            display: none;
        }
        .operate-group {
            display: flex;
            justify-content: space-between;
        }
        .box {
            background-color: #fff;
            box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
            border-radius: 12px;
        }
        .tabs-box {
            flex: 1;
            padding: 0 1.9rem;
        }
        .add-btn {
            background-color: $primary-btn-color;
            width: 7.2rem;
            height: 40px;
            box-shadow: 0px 1px 6px 1px rgba(4, 32, 93, 0.06);
            border-radius: 12px;
            color: #fff;
            @include bothCenter;
            margin-left: 12px;
            cursor: pointer;
            img {
                width: 15px;
                height: 15px;
                filter: brightness(0) invert(1);
                margin-right: 3px;
            }
        }
        .filter-box {
            position: relative;
            margin: 16px 0 24px;
            padding: 20px 1.38rem;
            /deep/ .filter-line {
                display: flex;
                &:not(:last-of-type) {
                    margin-bottom: 8px;
                }
                .title-name {
                    min-width: 6rem;
                    padding-top: 5px;
                    white-space: nowrap;
                }
                .filter-date-box {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    > .el-input {
                        .el-input__inner {
                            width: 12rem;
                            height: 2.2rem;
                            padding-left: 2.5rem;
                            border-color: #ededed;
                            border-radius: 1.6rem;
                            box-shadow: 0 0.06667rem 0.4rem 0.06667rem
                                rgba(0, 0, 0, 0.1);
                        }
                        .el-input__prefix {
                            left: 0.8rem;
                            .el-input__icon {
                                line-height: 2.2rem;
                            }
                        }
                    }
                }
                .filter-ipt {
                    width: 40%;
                    border-radius: 1.6rem;
                    box-shadow: 0 0.06667rem 0.4rem 0.06667rem
                        rgba(0, 0, 0, 0.1);
                    overflow: hidden;
                    padding: 0 0.6rem;
                    > .el-input {
                        .el-input__inner {
                            height: 2.2rem;
                            line-height: 2.2rem;
                        }
                        .el-input__prefix {
                            left: 0.2rem;
                            .el-input__icon {
                                line-height: 2.2rem;
                            }
                        }
                    }
                }
                .filter-select {
                    height: 2.2rem;
                    .el-input__inner {
                        height: 2.2rem;
                        line-height: 2.2rem;
                        border-radius: 1.6rem;
                        border: none;
                        box-shadow: 0 0.06667rem 0.4rem 0.06667rem
                            rgba(0, 0, 0, 0.1);
                    }
                    .el-input__suffix {
                        right: 0.5rem;
                        .el-input__icon {
                            line-height: 2.2rem;
                        }
                    }
                }
            }
            .export-box {
                position: absolute;
                bottom: 20px;
                right: 20px;
                > .el-button {
                    border-radius: 0.8rem;
                }
            }
        }
    }
    ::v-deep .el-tabs__item {
        font-size: 16px;
    }
    .load-text {
        display: none;
    }
}

/*移动端*/
@media only screen and (max-width: 767px) {
    $top-tabs-height: 3.9rem;
    .content-page {
        padding: $top-tabs-height 13px 40px;
        background-color: #f4f6fd;
        min-height: 100vh;
        .pc-header {
            display: none;
        }
        .top-tabs {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 999;
            background-color: #fff;
            height: $top-tabs-height;
            border-radius: 0 0 20px 20px;
            box-shadow: 0px 1px 12px 1px rgba(9, 16, 92, 0.08);
            text-align: center;
            .custom-tabs-style {
                display: inline-block;
            }
        }
        .add-user-box {
            width: 1.5rem;
            height: 1.5rem;
            position: absolute;
            right: 1.2rem;
            top: 0.8rem;
            border: 1px solid $primary-font-color;
            border-radius: 50%;
            @include bothCenter;
            .add-user {
                font-weight: 550;
                font-size: 1rem;
            }
        }

        .filter-line {
            margin: 18px 0;
            display: flex;
            justify-content: space-between;
            font-size: 0.86rem;
            font-weight: 550;
            .filter {
                flex: 1;
                border-radius: 12px;
                overflow: hidden;
                background-color: #fff;
                box-shadow: 0px 1px 6px 1px rgba(1, 27, 98, 0.05);
                position: relative;
                .search-btn {
                    position: absolute;
                    top: 50%;
                    right: 0.4rem;
                    transform: translateY(-50%);
                }
            }
            .add-btn {
                border-radius: 12px;
                background-color: #fff;
                min-width: 4rem;
                margin-left: 15px;
                box-shadow: 0px 1px 6px 1px rgba(1, 27, 98, 0.05);
                @include bothCenter;
            }
        }
    }
    ::v-deep .el-tabs__item.is-active {
        font-size: 1.14rem;
    }
    .pagination-container {
        display: none;
    }
    .load-text {
        padding: 1rem 0;
        text-align: center;
    }
}
.content-page {
    color: $primary-font-color;
}
.pagination-container {
    margin-top: 2rem;
    text-align: right;
}
::v-deep .el-tabs__nav-wrap::after {
    height: 0;
}
::v-deep .el-tabs__item:hover,
::v-deep .el-tabs__item.is-active {
    color: $primary-btn-color !important;
}
::v-deep .el-tabs__header {
    margin-bottom: 0;
}
::v-deep .el-tabs__item {
    color: #666666;
    font-weight: 550;
}
</style>
